var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01495 6.48667C7.66685 6.48667 8.45999 6.89346 9.39438 7.70704C10.3505 8.49863 10.8286 9.63104 10.8286 11.1043C10.8286 12.5555 10.2962 13.8858 9.2314 15.0952C8.16664 16.3046 6.89544 16.9093 5.41781 16.9093C3.94017 16.9093 2.7233 16.4805 1.76718 15.6229C0.811066 14.7654 0.333008 13.3911 0.333008 11.5001C0.333008 9.60905 1.19134 7.44318 2.908 5.00244C4.64639 2.56171 6.63468 0.989524 8.87286 0.285889C9.61168 0.681683 10.0137 1.28637 10.0789 2.09995C9.27486 2.73762 8.56864 3.52921 7.9602 4.47472C7.3735 5.39824 7.05841 6.06889 7.01495 6.48667ZM18.6839 6.48667C19.3358 6.48667 20.129 6.89346 21.0633 7.70704C22.0195 8.49863 22.4975 9.63104 22.4975 11.1043C22.4975 12.5555 21.9651 13.8858 20.9004 15.0952C19.8356 16.3046 18.5644 16.9093 17.0868 16.9093C15.6091 16.9093 14.3923 16.4805 13.4361 15.6229C12.5018 14.7654 12.0346 13.589 12.0346 12.0938C12.0346 10.5985 12.4148 9.03735 13.1754 7.41019C13.9577 5.76105 15.0116 4.27682 16.3371 2.9575C17.6626 1.63819 19.0751 0.747649 20.5744 0.285889C21.3132 0.703672 21.7152 1.30836 21.7804 2.09995C20.9547 2.73762 20.2376 3.52921 19.6292 4.47472C19.0425 5.39824 18.7274 6.06889 18.6839 6.48667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.c71e30e8f4216b969505195b98fcc199.svg";
export { ForwardRef as ReactComponent };